// @ts-nocheck

import * as React from 'react';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


import { styled } from '@mui/material/styles';

import { returnBasenameUrl } from '../../utils';

import {UploadImagesV2Props} from './UploadImagesV1V2types'
/*
export type UploadImagesV2Props = {
    clientid: string,
    usercode: string,
    targetdocid: number,
    nameprefix: string,
    namepostfix: string,
    namecontent: string,
    uplsource: string
}
*/


const STATUS_IDLE = 0
const STATUS_UPLOADING = 1

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

function UploadImagesV2(props) {
    const [files, setFiles] = React.useState([]);
    const [filesuploaded, setFilesuploaded] = React.useState([]);
    const [status, setStatus] = React.useState(STATUS_IDLE);
    
    const onFileChange = (e) => setFiles(e.target.files);

    const uploadFiles = (data) => {
        setStatus(STATUS_UPLOADING)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
            method: 'POST',
            body: data,
        })
        .then((response) =>  {
            if (!response.ok) return {} 
            else return response.json()
        })
        .then((data) => {
            console.log(data)
            if( typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean')
            {
                if(data.success === true){
                    if(data.data && typeof data.data === 'object' && data.data.length>0)
                    {
                        let arrfiles=[];
                        data.data.map( (file,i) =>{
                            let fo = {
                                filename: file.originalfile,
                                uploaded: true,
                                uploadedname: file.file
                            }
                            arrfiles.push(fo)
                        })
                        setFilesuploaded(arrfiles)
                        console.log("UploadImagesV2 arrfiles",arrfiles)
                    }
                }
                else {
                    
                }
            }
            else {

            }
        })
        .catch((err) => {
                console.error(err)
        })
        .finally(() => {
            setFiles([])
            setStatus(STATUS_IDLE)
        })
    };

    function packFiles(thefiles) {
        let basename=returnBasenameUrl()
        /* export type UploadImagesV2Props = {
            clientid: string,
            usercode: string,
            targetdocid: number,
            nameprefix: string, // example: "wc"
            namepostfix: string, // example: "image"
            namepart: string
        } */
        const data = new FormData();
        data.append("clientid",props.clientid);
        data.append("targetdocid", props.targetdocid);
        data.append("usercode", props.usercode);
        data.append("namepart", props.namepart);
        data.append("namepostfix", props.namepostfix);
        data.append("nameprefix", props.nameprefix);
        data.append("uplsource", props.uplsource);
        data.append("basename",basename);
        data.append("MAX_FILE_SIZE", "3000000");
        // @ts-ignore
        thefiles.forEach((file, i) => { 
            data.append(`${props.nameprefix}-${props.namepart}-${props.targetdocid}-${props.namepostfix}-${i}`, file, file.name); 
        });
        return data;
    }

    const renderFileForUploadList = () => (
        <Box>
        <Typography>Αρχείο προς αποστολή:</Typography>
        <ol>
            {[...files].map((f, i) => (
                <li key={i}>{`${f.name} - ${f.type}`}</li>
            ))} 
        </ol>
        </Box>);

    const renderFileList = () => (
    <Box>
    <Typography>Απεσταλθέντα αρχεία:</Typography>
    <ol>
        {[...filesuploaded].map((f, i) => (
            <li key={i}>{`${f.filename} - ${(f.uploaded)?'Uploaded':'FAILED'} `}{(f.uploaded)?<a href={`${f.uploadedname}`} target="_blank">view</a>:''}</li>
        ))}
    </ol>
    </Box>);

    const handleUploadClick = (e) => {
        // const chosenFiles = Array.prototype.slice.call(e.target.files)
        // if (chosenFiles.length) {
        //     const data = packFiles(chosenFiles)
        //     uploadFiles(data)
        // }
        // console.log("handleUploadClick files", files);
        const chosenFiles = Array.prototype.slice.call(files);
        // console.log("handleUploadClick chosenFiles", chosenFiles);
            // >>> a.push(...b)
            // If your browser does not support ECMAScript 6, you can use .apply instead:
            // >>> a.push.apply(a, b)
        const data = packFiles(chosenFiles);
        uploadFiles(data);
    };
    
    const getButtonStatusText = () => (
        (status === STATUS_IDLE) ?
            'αποστολη εικόνας/pdf' :
            "γινεται αποστολή..."
    );

    return (
    <div>
        <div>
        <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />}  >
            Επιλογή εικόνας/pdf
            <VisuallyHiddenInput
                type="file"
                accept=".jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.pdf,image/png,image/jpeg,application/pdf"
                onChange={(e) => setFiles(e.target.files)} 
            />
        </Button>
        </div>

        {renderFileForUploadList()}

        <div>
        <Button  variant="contained" endIcon={<SendIcon />}
            onClick={handleUploadClick}
            disabled={status === STATUS_UPLOADING}>
            {getButtonStatusText()}
        </Button> 
        </div>

        {renderFileList()}

    </div>
    );
}

export default UploadImagesV2